import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-52f1073c"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "game-panel" };
var _hoisted_2 = { class: "game-panel-inner" };
var _hoisted_3 = { class: "leaderboard" };
var _hoisted_4 = { class: "content-wrap" };
var _hoisted_5 = { class: "content" };
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "texts-wrap" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "home-title-head font-ang" }, "Miner's Rush"),
    /*#__PURE__*/ _createElementVNode("span", { class: "home-title font-ang" }, "Delete User Account")
], -1); });
var _hoisted_7 = { class: "col-12 col-md-12 col-xs-12" };
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "col-np-2 col-np-md-1 col-np-xs-1" }, null, -1); });
var _hoisted_9 = { class: "col-np-8 col-np-md-10 col-np-xs-10" };
var _hoisted_10 = { class: "panel" };
var _hoisted_11 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "panel-top" }, null, -1); });
var _hoisted_12 = { class: "panel-middle" };
var _hoisted_13 = { class: "panel-content" };
var _hoisted_14 = { key: 0 };
var _hoisted_15 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", null, "Deleting user account will remove all data associated with you.", -1); });
var _hoisted_16 = { key: 1 };
var _hoisted_17 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", null, "Please authorize to request removal of your account.", -1); });
var _hoisted_18 = {
    key: 0,
    class: "error"
};
var _hoisted_19 = { key: 2 };
var _hoisted_20 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", null, "Account successfully deleted.", -1); });
var _hoisted_21 = [
    _hoisted_20
];
var _hoisted_22 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "panel-bottom" }, null, -1); });
var _hoisted_23 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "col-np-2 col-np-md-1 col-np-xs-1" }, null, -1); });
var _hoisted_24 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "top-divider" }, null, -1); });
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, [
                            _hoisted_8,
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _hoisted_11,
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, [
                                            ($data.store.getters.isLogged && !$data.done)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                                    _hoisted_15,
                                                    _createElementVNode("div", {
                                                        class: "delete-button",
                                                        onClick: _cache[0] || (_cache[0] =
                                                            //@ts-ignore
                                                            function () {
                                                                var args = [];
                                                                for (var _i = 0; _i < arguments.length; _i++) {
                                                                    args[_i] = arguments[_i];
                                                                }
                                                                return ($options.deleteAccount && $options.deleteAccount.apply($options, args));
                                                            })
                                                    }, "Delete Account")
                                                ]))
                                                : _createCommentVNode("", true),
                                            (!$data.store.getters.isLogged && !$data.done)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                                    _hoisted_17,
                                                    _createElementVNode("form", {
                                                        onSubmit: _cache[4] || (_cache[4] = _withModifiers(function () { }, ["prevent"]))
                                                    }, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return (($data.username) = $event); }),
                                                            type: "text",
                                                            placeholder: "Username...",
                                                            class: "panel-input"
                                                        }, null, 512), [
                                                            [_vModelText, $data.username]
                                                        ]),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return (($data.password) = $event); }),
                                                            type: "password",
                                                            placeholder: "Password...",
                                                            class: "panel-input"
                                                        }, null, 512), [
                                                            [_vModelText, $data.password]
                                                        ]),
                                                        _createElementVNode("input", {
                                                            type: "submit",
                                                            name: "Log In",
                                                            class: "panel-input",
                                                            onClick: _cache[3] || (_cache[3] =
                                                                //@ts-ignore
                                                                function () {
                                                                    var args = [];
                                                                    for (var _i = 0; _i < arguments.length; _i++) {
                                                                        args[_i] = arguments[_i];
                                                                    }
                                                                    return ($options.login && $options.login.apply($options, args));
                                                                })
                                                        })
                                                    ], 32),
                                                    ($data.error != '')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, "Error: " + _toDisplayString($data.error), 1))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true),
                                            ($data.done)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _hoisted_21))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _hoisted_22
                                ])
                            ]),
                            _hoisted_23
                        ])
                    ])
                ]),
                _hoisted_24
            ])
        ])
    ]));
}
